import React, { CSSProperties } from 'react';

interface EyeProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const Eye: React.FC<EyeProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill={fill}>
        <defs />
        <path d="M663.05 530c0 76.42-59.79 138.38-133.54 138.38S395.97 606.43 395.97 530s59.79-138.38 133.54-138.38S663.05 453.57 663.05 530z" fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth="50px" />
        <ellipse cx="530" cy="530" fill="none" rx="425.37" ry="303" stroke={fill} strokeMiterlimit="10" strokeWidth="50px" />
      </g>
    </svg>
  );
};

export default Eye;
